import { render, staticRenderFns } from "./CollapseView.vue?vue&type=template&id=0462c57c&scoped=true&"
import script from "./CollapseView.vue?vue&type=script&lang=js&"
export * from "./CollapseView.vue?vue&type=script&lang=js&"
import style0 from "./CollapseView.vue?vue&type=style&index=0&id=0462c57c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0462c57c",
  null
  
)

export default component.exports